import { Box, Flex, Text, Image } from 'rebass';
import { UAContext } from '@quentin-sommer/react-useragent';
import { FaPhotoVideo, FaMicrophone } from "react-icons/fa";
import PropTypes from 'prop-types';
import React, { useState, useContext, useCallback } from 'react';

import { BiText } from "react-icons/bi";
// import RecordChatButton from 'chats/record-chat-button';
import BigSelfieButton from './big-selfie-button';
import { IoIosArrowBack } from 'react-icons/io';

import Modal from '../../app/modal/v2';
import NewStoryWithMediumButton from './medium-button';
import NewStoryMediumForm from './form';
import NewMultipleMedia from './multiple-media/index';
import LoadingIcon from 'app/inline-loading/index';
// import Tips from './Tips.png';
import RecordAudio from 'stories/tell-a-story/RecordAudio';

const NewMediaPopup = ({
  onClose,
  title,
  onSubmitText,
  onSubmitMedia,
  onSubmitExternalMedium,
  dividerText,
  isValidating,
  // onRecordChat,
}) => {
  const [currentForm, setCurrentForm] = useState('');
  const [showNarrationOptions, setShowNarrationOptions] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [initialFiles, setInitialFiles] = useState(false);
  const maxWidth = currentForm ? 620 : 414;
  const {
    uaResults: { android },
  } = useContext(UAContext);

  const handleChange = useCallback(
    (e, transcribe = false) => {
      setIsLoading(true)
      if (android) return setInitialFiles(e.target.files);
      return onSubmitMedia(e.target.files, transcribe);
    },
    [android, onSubmitMedia]
  );

  if (initialFiles)
    return (
      <NewMultipleMedia
        onClose={onClose}
        initialFiles={initialFiles}
        maxWidth={maxWidth}
        onSubmitMedia={files => onSubmitMedia(files)}
      />
    );

  const submitting = false;

  function getTitle() {
    if (currentForm === 'text')
      return "Write"
    if (currentForm)
      return `Add ${currentForm}`
    else
      return title
  }

  return (
    <Modal
      maxWidth={maxWidth}
      closeButtonLeft
      onClose={() => {
        if (currentForm)
          setCurrentForm('')
        else
          onClose()
      }}
      isActive={false}
    >
      <Modal.InnerWrap style={{ padding: 0, maxWidth: maxWidth, margin: "auto", marginTop: '0' }}>
        <Modal.Title style={{
          color: '#000',
          fontFamily: 'Poppins',
          fontSize: '22px',
          fontWeight: '400',
          lineHeight: '165%',
          marginTop: '10px',
        }}>{getTitle()}</Modal.Title>

        {(isLoading || isValidating) && <Box sx={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          bg: 'rgba(0,0,0, 0.15)',
          padding: '25%',
          zIndex: 1
        }}>
          <LoadingIcon />
        </Box>}
        <Box style={{ background: 'white', display: 'grid', borderRadius: '10px', paddingTop: currentForm === 'text' ? '30px' : undefined }}>
          <NewStoryMediumForm
            onSubmitText={onSubmitText}
            onSubmitExternalMedium={onSubmitExternalMedium}
            currentForm={currentForm}
            setCurrentForm={setCurrentForm}
          />
          {!currentForm && (showNarrationOptions ?
            <Box p={3} >
              <RecordAudio label="Audio" onSubmitMedia={onSubmitMedia} />
              <Box backgroundColor="#64748B" mx="auto" width={330} height={1} my={2} />
              <BigSelfieButton handleChange={handleChange} />
              <Box backgroundColor="#64748B" mx="auto" width={330} height={1} my={2} />
              <Flex
                height={40}
                width="min-content"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ borderRadius: 'medium', cursor: 'pointer' }}
                onClick={() => setShowNarrationOptions(false)}
              >
                <Text as={IoIosArrowBack} color="mineShaft" size={24} />
                <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={1} fontWeight={400} fontSize="15px">
                  Back
                </Text>
              </Flex>
            </Box>
            :
            <Box pt={0} >
              {/* <DottedDivider>Record a Narration</DottedDivider> */}
              <Flex p={3} flexDirection="column" justifyContent="space-around" width="100%">
                <NewStoryWithMediumButton
                  type="any"
                  disabled={submitting}
                  handleChange={handleChange}
                  label={<>Upload<br /> <Text color="#64748B" fontSize={16} fontWeight={400} >Photos or videos</Text></>}
                >
                  <Flex height="max-content" mr={1} justifyContent="center" alignItems="center" bg="#E3F5FF" p="14px" sx={{ borderRadius: '50%' }}>
                    <Box as={FaPhotoVideo} color="#26CBE1" minWidth={24} size={24} />
                  </Flex>
                </NewStoryWithMediumButton>
                <Box backgroundColor="#64748B" mx="auto" width={330} height={1} my={2} />

                <Flex sx={{ cursor: 'pointer' }} onClick={() => setCurrentForm('text')} justifyContent="space-between" width="100%" alignItems="center">
                  <Flex alignItems="center">
                    <Flex height="max-content" mr={1} justifyContent="center" alignItems="center" bg="#FFECF9" p="14px" sx={{ borderRadius: '50%' }}>
                      <Box as={BiText} color="#E36ABA" minWidth={24} size={24} />
                    </Flex>
                    <Text fontFamily="Poppins" fontSize={18} lineHeight="165%" fontWeight={500} color="#0E0E0E" >
                      Write
                      <br /> <Text maxWidth={280} color="#64748B" fontSize={16} fontWeight={400} >A thought, feeling or full description of a moment</Text>
                    </Text>
                  </Flex>
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                    <path d="M0.514648 2.34292L1.92885 0.928711L8.99995 7.99975L1.92885 15.0709L0.514648 13.6567L6.17155 7.99975L0.514648 2.34292Z" fill="#64748B" />
                  </svg>
                </Flex>
                <Box backgroundColor="#64748B" mx="auto" width={330} height={1} my={2} />

                <Flex onClick={() => setShowNarrationOptions(true)} justifyContent="space-between" sx={{ cursor: 'pointer' }} width="100%" alignItems="center">
                  <Flex alignItems="center">
                    <Flex height="max-content" mr={1} justifyContent="center" alignItems="center" bg="#FFF6E4" p="14px" sx={{ borderRadius: '50%' }}>
                      <Box as={FaMicrophone} color="#FFBC3E" minWidth={24} size={24} />
                    </Flex>
                    <Text fontFamily="Poppins" fontSize={18} lineHeight="165%" fontWeight={500} color="#0E0E0E" >
                      Narrate
                      <br /> <Text maxWidth={280} color="#64748B" fontSize={16} fontWeight={400} >Your voice or video recording, transcribed & tidied up by AI</Text>
                    </Text>
                  </Flex>
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                    <path d="M0.514648 2.34292L1.92885 0.928711L8.99995 7.99975L1.92885 15.0709L0.514648 13.6567L6.17155 7.99975L0.514648 2.34292Z" fill="#64748B" />
                  </svg>
                </Flex>

                {/* <NewStoryWithMediumButton
                type="any"
                disabled={submitting}
                handleChange={handleChange}
                label="Camera"
                capture
                >
                <ImageIcon />
                </NewStoryWithMediumButton> */}
              </Flex>
              {/* <Image src={Tips} /> */}
            </Box>
          )}
        </Box >
      </Modal.InnerWrap>
    </Modal >
  );
};

NewMediaPopup.defaultProps = {
  title: 'Add Media',
  dividerText: 'other types',
  pagePosition: null,
};

NewMediaPopup.propTypes = {
  title: PropTypes.string,
  dividerText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onRecordChat: PropTypes.func.isRequired,
  onSubmitText: PropTypes.func.isRequired,
  onSubmitMedia: PropTypes.func.isRequired,
  onSubmitExternalMedium: PropTypes.func.isRequired,
  pagePosition: PropTypes.number,
};

export default NewMediaPopup;
